<div class="row col-md-12" id="navigation_details" role="region" aria-label="Progress Information">
	<div class="col-md-11 text-left padding-right-0">
	<ul class="fl-r" aria-labelledby="navigation_details">
		<ng-container *ngFor="let breadcrumb of breadcrumbs;let i=index">
			<div class="visuallyhidden" role="region" [attr.aria-label]="getBreadcrumbStatus(breadcrumb.isActive)"></div>
			<li [id]="'bcName_'+breadCrumb_toCamelCase(breadcrumb.name)" [ngClass]="{'first':i===0,'nav-label-active':breadcrumb.isActive,'margin-top-li':i>0}" class="nav-label" *ngIf="breadcrumb.enable">{{breadcrumb.name}}
			</li>
		</ng-container>
	</ul>
	</div>
	<div class="col-md-1 clear-all" id="navigation_links">
		<ul aria-labelledby="navigation_links">
			<ng-container *ngFor="let breadcrumb of breadcrumbs;let i=index">
				<li [id]="'bcLine_'+breadCrumb_toCamelCase(breadcrumb.name)" [ngClass]="{'active':breadcrumb.isActive, 'multiline': breadcrumb.name.length > 20}" class="line" *ngIf="breadcrumb.enable"></li>
			</ng-container>
		</ul>
	</div>
</div>
